import React, {useEffect, useMemo, useState} from 'react';

import {observer} from 'mobx-react-lite';
import {appState} from '../../../store/AppStore';
import {useTranslation} from 'react-i18next';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {CustomersState} from '../../../store/users/customers/CustomersState';
import {Button, Space, Table} from 'antd';
import {Shell} from '../../../components/Shell';
import {PlusOutlined} from '@ant-design/icons';
import {AppRoutePaths} from '../../../routing/Routes';
import classNames from 'classnames';
import {paginationProps} from '../../serviceActions/utils/ServicesUtils';
import {customerListColumn} from '../utils/CustomerTableColumns';

export const CustomersListView: React.FC = observer((): JSX.Element => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [state] = useState(() => new CustomersState());
  const data = useMemo(() => state.items, [state.items]);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    state.loadCustomers();
  }, [state]);

  useEffect(() => {
    const customerId = searchParams.get('customerId');
    if (customerId) state.setCustomersFilters(Number(customerId));
  }, [searchParams, setSearchParams, state]);

  return (
    <>
      <Shell
        title={t('Customers')}
        actionButtons={[
          <Button
            type="primary"
            key="add"
            size="large"
            icon={<PlusOutlined />}
            onClick={() => navigate(AppRoutePaths.customerCreate.url)}
            className="shell-btn"
          >
            {t('Add Customer')}
          </Button>,
        ]}
      >
        <Space direction="vertical" className="w-full">
          <Space className={classNames('flex items-end')} />
          <div className="overflow-scroll">
            <Table
              rowKey="customerId"
              columns={customerListColumn}
              dataSource={data}
              loading={appState.isLoading}
              pagination={{
                ...paginationProps,
                current: state.pageNumber,
                total: state.total,
                pageSize: state.pageSize,
              }}
              onChange={(pagination, filters) => {
                state.setPagination(pagination);
                state.setFilters(filters);
              }}
            />
          </div>
        </Space>
      </Shell>
    </>
  );
});
